import {
  Box,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Skeleton,
  Stack,
  TextField,
} from "@mui/material";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import React, { memo } from "react";
import SimpleMDE from "react-simplemde-editor";
import fieldStyles from "../../../styles/fieldStyles";

const ReadOnlyInformasiKejadian = ({ input, setInput, loading }) => {
  if (loading) {
    return (
      <>
        <Box sx={styles.container}>
          <h3
            style={{
              color: "black",
              textAlign: "center",
            }}
          >
            INFORMASI KEJADIAN
          </h3>
          <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
          <br />
          <br />
          <Grid container spacing={3}>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            </Grid>
            <Grid item xl={6} lg={6} sm={6} xs={12}>
              <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            </Grid>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            </Grid>
          </Grid>
          <br />
          <Skeleton variant="rectangular" sx={{ fontSize: "2.5rem" }} />

          <Grid container spacing={2}>
            <Grid item>
              <br />
              <FormControl>
                <FormLabel>
                  <b>Kategori Incident</b>
                </FormLabel>
              </FormControl>
            </Grid>

            <Grid
              item
              container
              xl={12}
              lg={12}
              sm={12}
              xs={12}
              rowSpacing={2}
              columnSpacing={2}
              sx={{ margin: 0 }}
            >
              <Grid container spacing={3}>
                <Grid item xl={6} lg={6} sm={6} xs={12}>
                  <Stack spacing={2}>
                    <Skeleton variant="text" sx={{ fontSize: "2.7rem" }} />
                    <Skeleton variant="text" sx={{ fontSize: "2.7rem" }} />
                    <Skeleton variant="text" sx={{ fontSize: "2.7rem" }} />
                  </Stack>
                </Grid>
                <Grid item xl={6} lg={6} sm={6} xs={12}>
                  <Stack spacing={2}>
                    <Skeleton variant="text" sx={{ fontSize: "2.7rem" }} />
                    <Skeleton variant="text" sx={{ fontSize: "2.7rem" }} />
                    <Skeleton variant="text" sx={{ fontSize: "2.7rem" }} />
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Box maxWidth="md">
            <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
          </Box>

          <h4>Kriteria Pencatatan Insiden</h4>
          <Stack spacing={2} direction="row">
            <Box component="div" sx={styles.field}>
              <Skeleton
                variant="text"
                sx={{ fontSize: "2.7rem" }}
                width={200}
              />
            </Box>
            <Box component="div" sx={styles.field}>
              <Skeleton
                variant="text"
                sx={{ fontSize: "2.7rem" }}
                width={200}
              />
            </Box>
            <Box component="div" sx={styles.field}>
              <Skeleton
                variant="text"
                sx={{ fontSize: "2.7rem" }}
                width={200}
              />
            </Box>
          </Stack>
        </Box>
      </>
    );
  }

  return (
    <>
      <Box sx={styles.container}>
        <h3
          style={{
            color: "black",
            textAlign: "center",
          }}
        >
          INFORMASI KEJADIAN
        </h3>
        {/* <TextField
          label="Deskripsi singkat kejadian"
          variant="outlined"
          fullWidth
          type="text"
          multiline
          maxRows={100}
          disabled
          value={input.deskripsiSingkat}
        /> */}
        <SimpleMDE
          value={input.deskripsiSingkat}
          // options={{
          //   spellChecker: false,
          //   hideIcons: [
          //     "link",
          //     "image",
          //     "preview",
          //     "fullscreen",
          //     "guide",
          //     "side-by-side",
          //   ],
          // }}
          onChange={(value) => {
            setInput((prev) => ({
              ...prev,
              deskripsiSingkat: value,
            }));
          }}
        />
        <br />
        <br />
        <Grid container spacing={3}>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <FormControl fullWidth variant="standard">
              <InputLabel shrink={true}>Titik Kejadian (maps)</InputLabel>
              <Input
                type="text"
                value={input.locationTagLong + ", " + input.locationTagLat}
                fullWidth
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                    // onClick={ShowMap}
                    >
                      <AddLocationIcon />
                    </IconButton>
                  </InputAdornment>
                }
                disabled
              />
            </FormControl>
          </Grid>
          <Grid item xl={6} lg={6} sm={6} xs={12}>
            <TextField
              label="Nama Lokasi di Map"
              variant="standard"
              fullWidth
              value={input.namaLokasi || "-"}
              disabled
            />
          </Grid>
          <Grid item xl={12} lg={12} sm={12} xs={12}>
            <TextField
              label="Perusahaan Terlibat"
              variant="standard"
              fullWidth
              value={input.perusahaanTerlibat}
              disabled
            />
          </Grid>
        </Grid>
        <br />
        <FormControl>
          <FormLabel>
            <b>
              Kategori Hipo <small>(High Potential)</small>
            </b>
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="radio1"
            name="row-radio-buttons-group"
            onChange={(e) => {
              setInput({
                ...input,
                isHipo: e.target.value,
              });
            }}
            value={input.isHipo}
            // disabled={readOnly}
          >
            {/* Hardcode */}
            <FormControlLabel
              key={1}
              value={true}
              control={<Radio />}
              label={"Hipo"}
              // disabled={readOnly}
            />
            <FormControlLabel
              key={2}
              value={false}
              control={<Radio />}
              label={"Non - Hipo"}
              // disabled={readOnly}
            />
          </RadioGroup>
        </FormControl>
        <Grid container spacing={2}>
          <Grid item>
            <br />
            <FormControl>
              <FormLabel>
                <b>Kategori Incident</b>
              </FormLabel>
            </FormControl>
          </Grid>

          <Grid
            item
            container
            xl={12}
            lg={12}
            sm={12}
            xs={12}
            rowSpacing={2}
            columnSpacing={2}
            sx={{ margin: 0 }}
          >
            <Grid container spacing={3}>
              <Grid item xl={6} lg={6} sm={6} xs={12}>
                <Stack spacing={2}>
                  <SelectKI input={input} kategoriId={1} />
                  <SelectKI input={input} kategoriId={3} />
                  <SelectKI input={input} kategoriId={5} />
                </Stack>
              </Grid>
              <Grid item xl={6} lg={6} sm={6} xs={12}>
                <Stack spacing={2}>
                  <SelectKI input={input} kategoriId={2} />
                  <SelectKI input={input} kategoriId={4} />
                  <TextField
                    label={
                      input.listAllKategoriInsiden.find(
                        (o) => o.kategoriInsidenId === 6
                      )?.kategoriInsidenName
                    }
                    variant="standard"
                    fullWidth
                    disabled
                    value={
                      input.listAllKategoriInsiden.find(
                        (o) => o.kategoriInsidenId === 6
                      )?.detailKategoriInsidenName || ""
                    }
                  />
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box maxWidth="md">
          <p style={{ color: "red" }}>
            <small>
              <i>
                *) untuk kasus-kasus terkait dengan aspek securiti, dapat
                menggunakan format tersendiri (misal BAP) sesuai dengan
                ketentuan yang berlaku
              </i>
            </small>
          </p>
        </Box>

        <h4>Kriteria Pencatatan Insiden</h4>
        <Stack spacing={2} direction="row">
          <Box component="div" sx={fieldStyles}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="reportable"
                name="row-radio-buttons-group"
                defaultValue={input.isReportAble}
                onChange={(e) => {
                  setInput({
                    ...input,
                    isReportAble: e.target.value === "true",
                    isRecordAble: false,
                    isWorkRelated: false,
                  });
                }}
                // disabled={readOnly}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Reportable"
                  // disabled={readOnly}
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="Non Reportable"
                  // disabled={readOnly}
                />
              </RadioGroup>
            </FormControl>
          </Box>
          {input.isReportAble === "true" ||
            (input.isReportAble === true && (
              <Box component="div" sx={fieldStyles}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="radio1"
                    name="row-radio-buttons-group"
                    defaultValue={input.isWorkRelated}
                    onChange={(e) => {
                      setInput({
                        ...input,
                        isWorkRelated: e.target.value === "true",
                        isRecordAble: false,
                      });
                    }}
                    // disabled={readOnly}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Work Related"
                      // disabled={readOnly}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="Non Work Related"
                      // disabled={readOnly}
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            ))}
          {input.isWorkRelated === "true" ||
            (input.isWorkRelated === true && (
              <Box component="div" sx={fieldStyles}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="radio1"
                    name="row-radio-buttons-group"
                    defaultValue={input.isRecordAble + ""}
                    onChange={(e) => {
                      setInput({
                        ...input,
                        isRecordAble: e.target.value === "true",
                      });
                    }}
                    // disabled={readOnly}
                  >
                    <FormControlLabel
                      value={"true"}
                      control={<Radio />}
                      label="Recordable"
                      // disabled={readOnly}
                    />
                    <FormControlLabel
                      value={"false"}
                      control={<Radio />}
                      label="Non Recordable"
                      // disabled={readOnly}
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            ))}
        </Stack>
      </Box>
    </>
  );
};

const SelectKI = ({ input, kategoriId }) => {
  return (
    <FormControl>
      <FormLabel>
        {
          input.listAllKategoriInsiden.find(
            (o) => o.kategoriInsidenId === kategoriId
          )?.kategoriInsidenName
        }
      </FormLabel>
      <Select
        sx={{ marginTop: 0 }}
        disabled
        multiple
        value={input.listAllKategoriInsiden.filter(
          (dt) => dt.kategoriInsidenId == kategoriId && dt.isCheked
        )}
        input={<OutlinedInput />}
        displayEmpty
        renderValue={(selected) => (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
            }}
          >
            {selected.map((kItem, idx) =>
              kItem.kategoriInsidenId === kategoriId ? (
                <Chip
                  key={idx}
                  label={
                    input.listAllKategoriInsiden.find(
                      (e) =>
                        e?.detailKategoriInsidenId ===
                          kItem?.detailKategoriInsidenId &&
                        kItem.isCheked === true
                    )?.detailKategoriInsidenName
                  }
                />
              ) : null
            )}
          </Box>
        )}
      />
    </FormControl>
  );
};

const styles = {
  container: {
    px: 5,
    mt: 3,
    pt: 1,
    pb: 5,
    borderRadius: 3,
    display: "block",
    backgroundColor: "#fff",
  },
  field: {
    border: 1,
    borderColor: "lightgrey",
    px: 3,
    py: 2,
    borderRadius: 3,
    display: "block",
    backgroundColor: "#fff",
  },
};

export default memo(ReadOnlyInformasiKejadian);
